import { ENTITY_TYPE } from "constants/phase";
import React, { useContext, useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";

import { SocketContext } from "../../../context/socket";
import { InfoIcon } from "../../icons";

const DownloadStats = (props) => {
  const { webhookSocket } = useContext(SocketContext);
  const { downloadStats, setDownloadStats, clientSetting, entityType, entityId } = useOutletContext();
  const { isVisible = false } = props;
  const [socketUpdate, setSocketUpdate] = useState({});

  useEffect(() => {
    webhookSocket.on(`publisher_downloadStats${entityId}`, ({ data }) => {
      //call socket use effect here
      setSocketUpdate({
        entityId: entityId,
        uniqueId: data?.uniqueId,
        payload: data.payload,
        status: data?.status || false,
      });
    });
  }, [entityId, webhookSocket]);

  useEffect(() => {
    if (socketUpdate.status) {
      setDownloadStats(socketUpdate.payload);
    }
  }, [setDownloadStats, socketUpdate]);

  return (
    <>
      {clientSetting?.permissions?.isProcessingLimit && entityType === ENTITY_TYPE.WORKSPACES && isVisible ? (
        <div className="download-satus-container p-2">
          <div className="mx-3 my-auto">
            <InfoIcon />
          </div>
          <div className="mx-3 my-auto">
            Downloaded Clips:
            {downloadStats?.downloadClipCount ? downloadStats?.downloadClipCount : 0}
          </div>
          <hr className="mx-3 my-auto" />
          <div className="mx-3 my-auto">
            Downloaded Highlights: {downloadStats?.downloadHighlightCount ? downloadStats?.downloadHighlightCount : 0}{" "}
          </div>
          <hr className="mx-3 my-auto" />
          <div className="mx-3 my-auto">
            Total download duration:{" "}
            {downloadStats?.totalUsedDuration ? `${downloadStats.totalUsedDuration.toFixed(2)}s` : 0}
            {clientSetting?.limitation?.maxVideoDownloadDuration
              ? ` / ${Math.trunc(clientSetting?.limitation?.maxVideoDownloadDuration)}s`
              : ""}{" "}
            used{" "}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default DownloadStats;
